<template>
    <router-link :to="routerLink">
        <div class="item-pill item-default">
            <div class="image">
                <ion-img :src="thumbnail" :alt="title" />
            </div>
            <div class="description">
                <div class="head">
                    <div class="date">{{ dateFrom }} - {{ dateTo }}</div>
                    <div :class="'status '+ statusColor"><span class="dot"><svg width="20" height="20" viewBox="0 0 20 20"><circle cx="10" cy="10" r="4.5" /></svg></span><span class="label">{{ statusLabel }}</span></div>
                </div>
                <h3 class="title h5">{{ title }}</h3>
                <div class="excerpt">{{ excerpt }}</div>
            </div>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: 'ItemPill',
        props: {
            data : {
                type: [Array, Object],
                required : true
            }
        },
        computed:{
            active(){
                return this.data.status;
            },
            newStatus(){
                return this.data.newStatus;
            },
            statusLabel(){
                let label = '';
                if(this.newStatus == 'active') label = "Aktywna";
                if(this.newStatus == 'no-active') label = "Zakonczona";
                if(this.newStatus == 'read') label = "Przeczytana";
                return label;
            },
            statusColor(){
                let color = '';
                if(this.newStatus == 'active') color = "active";
                if(this.newStatus == 'no-active') color = "closed";
                if(this.newStatus == 'read') color = "active";
                return color;
            },
            thumbnail(){
                return this.data.thumbnail;
            },
            title(){
                return this.data.title;
            },
            excerpt(){
                return this.data.excerpt;
            },
            dateFrom(){
                return this.data.dateFrom;
            },
            dateTo(){
                return this.data.dateTo;
            },
            slug(){
                return this.data.slug;
            },
            routerLink(){
                return { name: 'PillSingle', params: { slug: this.slug }}
            }
        }
    }
</script>